import { render, staticRenderFns } from "./LeftSide.vue?vue&type=template&id=2fa93b3c&scoped=true"
import script from "./LeftSide.vue?vue&type=script&lang=js"
export * from "./LeftSide.vue?vue&type=script&lang=js"
import style0 from "./LeftSide.vue?vue&type=style&index=0&id=2fa93b3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa93b3c",
  null
  
)

export default component.exports